import { useEffect, useState } from "react";
import MasterLayout from "./MasterLayout";
import { masterFetch } from "./masterApi";

export default function MasterPlans() {
  const [plans, setPlans] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", description: "", price_monthly: 0, currency: "EUR", stripe_price_id: "", max_sites: 5, max_operators: 10, features: "" });
  const [err, setErr] = useState("");

  async function load() {
    try { setPlans((await masterFetch("/plans")).plans || []); }
    catch (e) { setErr(e.message); }
  }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        price_monthly: parseFloat(form.price_monthly) || 0,
        max_sites: parseInt(form.max_sites) || 0,
        max_operators: parseInt(form.max_operators) || 0,
        features: form.features.split(",").map(f => f.trim()).filter(Boolean),
      };
      await masterFetch("/plans", { method: "POST", body: JSON.stringify(payload) });
      setCreating(false);
      setForm({ name: "", description: "", price_monthly: 0, currency: "EUR", stripe_price_id: "", max_sites: 5, max_operators: 10, features: "" });
      load();
    } catch (e) { alert(e.message); }
  }

  async function toggle(p) {
    await masterFetch(`/plans/${p.id}`, { method: "PUT", body: JSON.stringify({ is_active: !p.is_active }) });
    load();
  }

  return (
    <MasterLayout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0, fontSize: 26 }}>Subscription plans</h1>
        <button data-testid="add-plan" onClick={() => setCreating(true)} style={btnPrimary}>+ New plan</button>
      </div>
      <div style={{ opacity: 0.55, fontSize: 13, marginBottom: 24 }}>
        Define what tenants can rent. Set Stripe Price IDs from your Stripe dashboard.
      </div>

      {err && <div style={errBox}>{err}</div>}

      {creating && (
        <form onSubmit={submit} style={card}>
          <Row><Lbl>Plan name *</Lbl><input data-testid="plan-name" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} style={inp} /></Row>
          <Row><Lbl>Description</Lbl><input value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={inp} /></Row>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
            <Row><Lbl>Price / month</Lbl><input type="number" min="0" step="0.01" value={form.price_monthly} onChange={e => setForm({...form, price_monthly: e.target.value})} style={inp} /></Row>
            <Row><Lbl>Currency</Lbl><select value={form.currency} onChange={e => setForm({...form, currency: e.target.value})} style={inp}><option>EUR</option><option>USD</option><option>NOK</option><option>GBP</option></select></Row>
            <Row><Lbl>Stripe price id</Lbl><input value={form.stripe_price_id} onChange={e => setForm({...form, stripe_price_id: e.target.value})} style={inp} placeholder="price_..." /></Row>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Row><Lbl>Max sites</Lbl><input type="number" min="0" value={form.max_sites} onChange={e => setForm({...form, max_sites: e.target.value})} style={inp} /></Row>
            <Row><Lbl>Max operators</Lbl><input type="number" min="0" value={form.max_operators} onChange={e => setForm({...form, max_operators: e.target.value})} style={inp} /></Row>
          </div>
          <Row><Lbl>Features (comma-separated)</Lbl><input value={form.features} onChange={e => setForm({...form, features: e.target.value})} style={inp} placeholder="Priority support, Custom domain" /></Row>
          <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
            <button type="submit" style={btnPrimary} data-testid="plan-submit">Create</button>
            <button type="button" onClick={() => setCreating(false)} style={btnGhost}>Cancel</button>
          </div>
        </form>
      )}

      <div data-testid="plans-table" style={tableWrap}>
        <div style={{ ...tHead, gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr" }}>
          <span>NAME</span><span>PRICE</span><span>STRIPE</span><span>MAX SITES</span><span>STATUS</span><span style={{textAlign:"right"}}>ACTION</span>
        </div>
        {plans.length === 0 && <div style={empty}>No plans yet.</div>}
        {plans.map(p => (
          <div key={p.id} style={{ ...tRow, gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr" }}>
            <span><div style={{ fontWeight: 500 }}>{p.name}</div><div style={{ opacity: 0.4, fontSize: 11 }}>{p.description}</div></span>
            <span>{p.price_monthly} {p.currency}</span>
            <span style={{ fontSize: 10, opacity: 0.6, fontFamily: "monospace" }}>{p.stripe_price_id || "—"}</span>
            <span>{p.max_sites}</span>
            <span style={{ color: p.is_active ? "#34d399" : "#9ca3af" }}>{p.is_active ? "active" : "inactive"}</span>
            <span style={{ textAlign: "right" }}>
              <button onClick={() => toggle(p)} style={btnSmall}>{p.is_active ? "Disable" : "Enable"}</button>
            </span>
          </div>
        ))}
      </div>
    </MasterLayout>
  );
}

const Row = ({children}) => <div style={{marginBottom:10}}>{children}</div>;
const Lbl = ({children}) => <label style={{ display:"block", fontSize:11, letterSpacing:1.5, opacity:0.7, marginBottom:4, textTransform:"uppercase" }}>{children}</label>;
const card = { background: "#0f0a1c", border: "1px solid #1f1232", padding: 20, borderRadius: 12, marginBottom: 22 };
const inp = { width: "100%", padding: "9px 11px", background: "#06050d", border: "1px solid #3a2a55", borderRadius: 8, color: "#fff", fontSize: 13, fontFamily: "inherit" };
const tableWrap = { background: "#0f0a1c", border: "1px solid #1f1232", borderRadius: 12, overflow: "hidden" };
const tHead = { display: "grid", padding: "12px 16px", fontSize: 11, letterSpacing: 2, opacity: 0.5, borderBottom: "1px solid #1f1232" };
const tRow = { display: "grid", padding: "12px 16px", borderBottom: "1px solid #1a1029", alignItems: "center", fontSize: 13 };
const empty = { padding: 20, opacity: 0.4, fontSize: 13 };
const btnPrimary = { padding: "9px 16px", background: "linear-gradient(135deg,#8b5cf6,#a855f7)", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 13, fontFamily: "inherit" };
const btnGhost = { padding: "9px 16px", background: "transparent", color: "#a89ec9", border: "1px solid #3a2a55", borderRadius: 8, cursor: "pointer", fontSize: 13, fontFamily: "inherit" };
const btnSmall = { padding: "5px 10px", background: "transparent", color: "#a89ec9", border: "1px solid #3a2a55", borderRadius: 6, cursor: "pointer", fontSize: 11, fontFamily: "inherit" };
const errBox = { padding: 14, background: "rgba(255,80,90,0.1)", border: "1px solid rgba(255,80,90,0.4)", color: "#ff7886", borderRadius: 8, fontSize: 13, marginBottom: 16 };
